import { ReactComponent as Svg } from "../../assets/svg/hero.svg";
import styled from "styled-components";

const HeroSvg = styled(Svg)``;

export default HeroSvg;
